<!-- Streamlined style (simple bars) -->
@if (style === 'streamlined') {
  <div class="stepper-container">
    @for (step of streamlinedSteps; track $index) {
      <div
        class="step"
        [class.completed]="isStepCompleted(step)">
      </div>
    }
  </div>
}

<!-- Traditional style (circles with icons and labels) -->
@if (style === 'traditional') {
  <div class="traditional-container">
    <!-- Dotted continuation connector before first visible step -->
    @if (hasMoreBefore) {
      <div class="connector dotted"></div>
    }
    @for (step of visibleSteps; track $index; let i = $index; let last = $last) {
      <div class="step-item" [class]="step.state" (pointerdown)="onStepClick(i)">
        <div class="step-icon-wrapper">
          <div class="step-icon">
            <!-- Complete state: checkmark -->
            @if (step.state === 'complete') {
              <cs-icon name="checkmark"></cs-icon>
            }
            <!-- Partial state: time/clock icon -->
            @if (step.state === 'partial') {
              <cs-icon name="time"></cs-icon>
            }
            <!-- Current state: inner dot -->
            @if (step.state === 'current') {
              <div class="current-dot"></div>
            }
            <!-- Pending state: empty circle (no content needed) -->
          </div>
        </div>
        @if (step.label) {
          <span class="step-label">{{ step.label }}</span>
        }
      </div>
      <!-- Connector line between steps -->
      @if (!last) {
        <div
          class="connector"
          [class.complete]="getConnectorState(i) === 'complete'">
        </div>
      }
    }
    <!-- Dotted continuation connector after last visible step -->
    @if (hasMoreAfter) {
      <div class="connector dotted"></div>
    }
  </div>
}
